export default __webpack_public_path__ + "static/media/keycloak.fc1f8846.svg";